import React, { useState } from 'react';
import INSTRUKCJE from '../pomoc/samouczki';

/**
 * Strona "Jak korzystac z panelu" - instrukcje dla pracownikow.
 *
 * Kazda instrukcja ma dwie postacie: rozwijana na ekranie (do czytania przy pracy)
 * oraz PDF do wydruku (do powieszenia na zapleczu). Obie pochodza z tej samej
 * tresci, wiec nie moga sie rozjechac.
 *
 * Zrzuty ekranu i PDF-y leza w frontend/public/instrukcje/ - sa czescia repozytorium,
 * wiec deploy je przenosi razem z aplikacja i nie wymagaja osobnego katalogu
 * na serwerze (inaczej niz zalaczniki reklamacji czy komunikatora).
 *
 * UWAGA NA NAZWE KATALOGU: pliki MUSZA lezec pod inna nazwa niz trasa strony.
 * Przy katalogu 'public/pomoc/' i trasie '/pomoc' nginx widzial istniejacy katalog,
 * probowal pokazac jego zawartosc, listowanie jest wylaczone - i zwracal
 * 403 Forbidden zamiast przepuscic zadanie do aplikacji. Stad 'instrukcje'.
 *
 * DODAWANIE KOLEJNEJ INSTRUKCJI: nowy plik w frontend/src/pomoc/samouczki/ i wpis w index.js tamze.
 */

export default function PomocPage() {
  const [otwarta, setOtwarta] = useState(INSTRUKCJE[0].id);
  const [powiekszony, setPowiekszony] = useState(null);

  return (
    <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
      <div className="card" style={{ marginBottom: '16px' }}>
        <h2 style={{ margin: '0 0 4px', fontSize: '18px', fontWeight: 700 }}>
          Jak korzystać z panelu
        </h2>
        <div style={{ fontSize: '12px', color: 'var(--text-muted)' }}>
          Instrukcje krok po kroku. Każdą możesz przeczytać tutaj albo pobrać i wydrukować.
        </div>
      </div>

      {INSTRUKCJE.map((ins) => {
        const rozwinieta = otwarta === ins.id;
        return (
          <div className="card" key={ins.id} style={{ marginBottom: '14px' }}>
            {/* Naglowek instrukcji */}
            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '10px' }}>
              <button
                type="button"
                onClick={() => setOtwarta(rozwinieta ? null : ins.id)}
                /* Tlo LINIOWE - v3sys-theme.css wymusza wlasne tlo kazdego <button>
                   regula z !important, ktorej klasa nie pokona. */
                style={{
                  background: 'var(--card-bg)', border: '1px solid var(--border)',
                  color: 'var(--text)', fontSize: '12px', padding: '6px 12px',
                  borderRadius: 'var(--radius)', cursor: 'pointer', fontWeight: 600,
                }}
                aria-expanded={rozwinieta}
              >
                {rozwinieta ? '▾' : '▸'} {ins.tytul}
              </button>

              <span style={{ fontSize: '11px', color: 'var(--text-muted)' }}>
                {ins.dlaKogo} · {ins.czas}
              </span>

              <a
                href={ins.pdf}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  marginLeft: 'auto', background: 'var(--primary)', color: '#fff',
                  border: '1px solid var(--primary)', fontSize: '12px', padding: '6px 12px',
                  borderRadius: 'var(--radius)', textDecoration: 'none', fontWeight: 600,
                  whiteSpace: 'nowrap',
                }}
              >
                Pobierz PDF
              </a>
            </div>

            {rozwinieta && (
              <div style={{ marginTop: '14px' }}>
                <p style={{ fontSize: '13px', color: 'var(--text-secondary)', margin: '0 0 16px', maxWidth: '70ch' }}>
                  {ins.wstep}
                </p>

                {ins.kroki.map((k, idx) => (
                  <div key={k.n} style={{ marginBottom: '22px' }}>
                    {/* Naglowek dzialu pokazujemy tylko przy PIERWSZYM kroku danego dzialu */}
                    {k.dzial && ins.dzialy && ins.dzialy[k.dzial] && (idx === 0 || ins.kroki[idx - 1].dzial !== k.dzial) && (
                      <div style={{
                        display: 'flex', alignItems: 'flex-start', gap: '10px',
                        margin: '26px 0 18px', paddingBottom: '10px',
                        borderBottom: '2px solid var(--text)',
                      }}>
                        <span style={{
                          background: 'var(--text)', color: 'var(--card-bg)', fontWeight: 700,
                          fontSize: '13px', minWidth: '26px', height: '26px', borderRadius: '4px',
                          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                          flexShrink: 0,
                        }}>{k.dzial}</span>
                        <div>
                          <div style={{ fontSize: '15px', fontWeight: 700, lineHeight: 1.3 }}>
                            {ins.dzialy[k.dzial].tytul}
                          </div>
                          <div style={{ fontSize: '12px', color: 'var(--text-muted)', marginTop: '2px', maxWidth: '68ch' }}>
                            {ins.dzialy[k.dzial].opis}
                          </div>
                        </div>
                      </div>
                    )}
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px', marginBottom: '5px' }}>
                      <span style={{
                        background: 'var(--danger)', color: '#fff', fontWeight: 700, fontSize: '11px',
                        minWidth: '20px', height: '20px', borderRadius: '50%', display: 'inline-flex',
                        alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                      }}>{k.n}</span>
                      <strong style={{ fontSize: '14px' }}>{k.tytul}</strong>
                    </div>
                    <p style={{ fontSize: '13px', margin: '0 0 8px', maxWidth: '70ch', lineHeight: 1.6 }}>
                      {k.tresc}
                    </p>
                    {k.obraz && (
                      <img
                        src={k.obraz.plik}
                        alt={k.obraz.opis}
                        onClick={() => setPowiekszony(k.obraz)}
                        style={{
                          width: '100%', maxWidth: '860px', border: '1px solid var(--border)',
                          borderRadius: 'var(--radius)', cursor: 'zoom-in', display: 'block',
                        }}
                      />
                    )}
                  </div>
                ))}

                <div style={{
                  background: 'var(--bg)', border: '1px solid var(--border)',
                  borderLeft: '3px solid var(--warning, #B45309)',
                  borderRadius: 'var(--radius)', padding: '12px 14px',
                }}>
                  <strong style={{ fontSize: '13px', display: 'block', marginBottom: '6px' }}>Na co uważać</strong>
                  <ul style={{ margin: 0, paddingLeft: '18px', fontSize: '12.5px', lineHeight: 1.65 }}>
                    {(ins.uwagi || []).map((u, i) => <li key={i} style={{ marginBottom: '4px' }}>{u}</li>)}
                  </ul>
                </div>
              </div>
            )}
          </div>
        );
      })}

      {/* Powiekszenie zrzutu - na ekranie kasy zrzuty sa male, a szczegoly wazne */}
      {powiekszony && (
        <div
          onClick={() => setPowiekszony(null)}
          role="presentation"
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,.82)', zIndex: 1050,
            display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px',
            cursor: 'zoom-out',
          }}
        >
          <img
            src={powiekszony.plik}
            alt={powiekszony.opis}
            style={{ maxWidth: '100%', maxHeight: '100%', borderRadius: '4px' }}
          />
        </div>
      )}
    </div>
  );
}
